// @flow
import React from 'react'
import Checkbox from '../controls/Checkbox'
import _ from 'lodash'
import NodeTags from './NodeTags'

import type { Node as NodeType } from '../types'

type Props = {|
  node: NodeType,
  expandedIds: Object,
  triggerNodeExpanded: Function,
  triggerNodeSelected: Function
|}

export default function Node(props: Props) {
  const { node, expandedIds, triggerNodeExpanded, triggerNodeSelected } = props

  const hasChildren = !_.isEmpty(node.children)
  const isExpanded = hasChildren && isNodeExpanded(node, expandedIds)

  return (
    <NodeTags.Wrapper hasChildren={hasChildren} key={node.id}>
      <NodeTags.Node>
        {hasChildren && (
          <NodeTags.Expander
            isExpanded={isExpanded}
            onClick={() => triggerNodeExpanded(node.id, !isExpanded)}
          />
        )}
        <NodeTags.Option
          onClick={() => !node.disabled && triggerNodeSelected(node)}
          className="fs-Node__option"
        >
          <Checkbox
            compact
            alignBaseline
            disabled={node.disabled}
            checked={node.isSelected}
            label={node.label}
            invisible={node.hideCheckbox}
          />
        </NodeTags.Option>
      </NodeTags.Node>
      {isExpanded && (
        <NodeTags.Children>
          {_.map(_.sortBy(node.children, 'label'), (node) => (
            <Node
              key={node.id}
              node={node}
              expandedIds={expandedIds}
              triggerNodeExpanded={triggerNodeExpanded}
              triggerNodeSelected={triggerNodeSelected}
            />
          ))}
        </NodeTags.Children>
      )}
    </NodeTags.Wrapper>
  )
}

function isNodeExpanded(node, expandedIds) {
  const { id, children } = node

  if (_.isBoolean(expandedIds[id])) return expandedIds[id]

  return _.some(children, nodeSubtreeHasSelectedItems)
}

function nodeSubtreeHasSelectedItems(node) {
  return node.isSelected || _.some(node.children, (child) => nodeSubtreeHasSelectedItems(child))
}
